var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
import { Service } from '~/core/service';
var DataImportExcelInfoService = /** @class */ (function (_super) {
    __extends(DataImportExcelInfoService, _super);
    function DataImportExcelInfoService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取所有批次号信息
     */
    DataImportExcelInfoService.prototype.getAllBatchNumbers = function () {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getAllBatchNumbers,
        });
    };
    /**
     * 案件按批次号删除
     */
    DataImportExcelInfoService.prototype.deleteDataExcelInfoByBatch = function (data) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.deleteDataExcelInfoByBatch,
            data: data,
        });
    };
    /**
     * 案件导入确定
     */
    DataImportExcelInfoService.prototype.importExcelData = function (data) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.importExcelData,
            data: data,
            loading: true
        });
    };
    /**
     * 获取案件导入信息
     */
    DataImportExcelInfoService.prototype.getAllImportExcelInfos = function (data, page) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getAllImportExcelInfos,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalName: data.principalName,
                personalName: data.personalName,
                principalId: data.principalId,
                partnerName: data.partnerName,
                bankName: data.bankName,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                carNo: data.carNo,
                overdueAmountStart: data.amountRange.min,
                overdueAmountEnd: data.amountRange.max,
            },
            page: page,
        });
    };
    /**
     * 根据PrincipalId查找模板
     */
    DataImportExcelInfoService.prototype.findTempletByPrincipalId = function (data) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.findTempletByPrincipalId,
            data: data,
        });
    };
    /**
     * 根据导入案件Id获取导入信息
     */
    DataImportExcelInfoService.prototype.getImportDataInfoById = function (data) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportDataInfoById,
            data: data,
        });
    };
    /**
     * 客户信息查询
     */
    DataImportExcelInfoService.prototype.getImportPersonalInfo = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportPersonalInfo,
            data: {
                id: caseId
            }
        });
    };
    DataImportExcelInfoService.prototype.importTopInfo = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.importTopInfo,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 客户产品信息查询
     */
    DataImportExcelInfoService.prototype.getImportProduct = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportProduct,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 客户收支状况查询
     */
    DataImportExcelInfoService.prototype.getImportPersonalIncome = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportPersonalIncome,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 客户房产信息查询
     */
    DataImportExcelInfoService.prototype.getImportPersonalHouse = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportPersonalHouse,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 客户联系人信息查询
     */
    DataImportExcelInfoService.prototype.getImportPersonalContacts = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportPersonalContacts,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 客户联系人地址信息查询
     */
    DataImportExcelInfoService.prototype.getPersonalAddresses = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getPersonalAddresses,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 案件信息查询
     */
    DataImportExcelInfoService.prototype.getImportCaseInfo = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportCaseInfo,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 客户开户信息查询
     */
    DataImportExcelInfoService.prototype.getImportPersonalBank = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportPersonalBank,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 查询导入案件共债案件
     */
    DataImportExcelInfoService.prototype.getImportDebtCaseInfo = function (caseId) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.getImportDebtCaseInfo,
            data: {
                id: caseId
            }
        });
    };
    /**
     * 自动匹配
     */
    DataImportExcelInfoService.prototype.fileAutoMatch = function (data) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.fileAutoMatch,
            data: {
                fileList: data
            }
        });
    };
    /**
     * 附件导入
     */
    DataImportExcelInfoService.prototype.fileImport = function (data) {
        return this.netService.send({
            server: dataimpService.dataImportExcelInfoController.fileImport,
            data: {
                importList: data
            }
        });
    };
    __decorate([
        Inject(NetService)
    ], DataImportExcelInfoService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], DataImportExcelInfoService.prototype, "getAllBatchNumbers", null);
    __decorate([
        Debounce()
    ], DataImportExcelInfoService.prototype, "deleteDataExcelInfoByBatch", null);
    __decorate([
        Debounce()
    ], DataImportExcelInfoService.prototype, "importExcelData", null);
    __decorate([
        Debounce()
    ], DataImportExcelInfoService.prototype, "getAllImportExcelInfos", null);
    return DataImportExcelInfoService;
}(Service));
export { DataImportExcelInfoService };
